import { Typography, Table as TableAtom } from 'antd';
import styled from 'styled-components';
import { AddButton } from 'components/atoms/button';
import { EmptyStateContainer as EmptyStateContainerAtom } from 'components/atoms/empty-state';
import { Page } from 'components/molecules/page';
import {
  BodyShort01,
  ProductiveHeading05,
  ProductiveHeading06,
  Text02,
} from 'components/styles';

export const StyledTable = styled(TableAtom)`
  margin: var(--spacing-05);
  margin-top: var(--spacing-03);
  overflow: auto;
  .ant-table-layout-fixed table {
    table-layout: auto;
  }
  .ant-table.ant-table-bordered > .ant-table-container {
    border: none;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > tbody
    > tr
    > td {
    border-right: none;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-body
    > table
    > tbody
    > tr
    > td {
    border-right: none;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > thead
    > tr:not(:last-child)
    > th {
    font-weight: var(--heading-6-weight);
    color: var(--cool-gray-80);
  }

  .ant-table-thead > tr > th {
    background: var(--coolest-gray-20);
    border-bottom: none;
    padding: var(--spacing-03);
    font-weight: var(--heading-6-weight);
    color: var(--cool-gray-80);
  }

  .ant-table-tbody > tr > td {
    padding: var(--spacing-03);
    border-bottom: 1px solid var(--gray-10) !important;
  }

  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-header
    > table
    > thead
    > tr
    > th {
    border-right: solid 1px var(--gray-10);
  }
`;

export const StyledText = styled(Typography.Text)``;

export const Header = styled.span`
  padding-bottom: var(--spacing-04);
`;

export const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  padding-bottom: var(--spacing-05);
  background-color: var(--white-100);
`;

export const StyledPage = styled(Page)`
  ${Page.Content} {
    padding: var(--layout-01);
    margin-bottom: 80px;
  }
  ${Page.Header.Title} {
    flex: 1;
  }
`;
export const HelpText = styled.div`
  ${Text02};
`;

export const PageContentWrapper = styled(Page.Content)`
  padding-top: 0 !important;
  display: flex;
  gap: var(--spacing-07);
  flex-direction: column;
  margin-bottom: var(--spacing-09) !important;
  overflow: auto;
`;

export const AddFieldWrapper = styled.div`
  padding-bottom: var(--spacing-05) 0 0 0;
  background-color: var(--white-100);
`;

export const BarWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: var(--spacing-03) 0 0 0;
  margin-bottom: 0;
`;

export const TableHeader = styled.div`
  ${ProductiveHeading06};
  padding-left: var(--spacing-04);
  margin-bottom: var(--spacing-03);
`;

export const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  padding: var(--spacing-03);
  padding-top: var(--spacing-10);
  && {
    text-align: left;
  }
  color: var(--gray-80);
`;

export const TitleWrapper = styled.div`
  background: #f9f9fa;
`;

export const Title = styled.div`
  ${ProductiveHeading05};
`;

export const TitleDescription = styled.div`
  ${BodyShort01};
  color: var(--gray-50);
  max-width: 23rem;
  font-size: var(--font-size-sm);
`;

export const StyledAddButton = styled(AddButton)`
  margin-right: var(--spacing-05);
`;

export const TableTitleWrapper = styled.div`
  display: flex;
  gap: var(--spacing-02);
  justify-content: center;
  align-items: center;
`;

export const DurationBetweenKeyEventsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-02);
`;
